import AppleImg from 'assets/payment/apple.png'
import GoogleImg from 'assets/payment/google.png'
import MasterImg from 'assets/payment/master.png'
import VisaImg from 'assets/payment/visa.png'
import AmericanImg from 'assets/payment/american_express.png'
import KlarnaImg from 'assets/payment/klarna.png'
import ObImg from 'assets/payment/ob.png'
import AmazonImg from 'assets/payment/amazon.png'
import BlikImg from 'assets/payment/blik.png'
import DealImg from 'assets/payment/deal.png'
import UnionImg from 'assets/payment/union.png'
import JsbImg from 'assets/payment/jsb.png'
import DiscoverImg from 'assets/payment/discover.png'
import BancontactImg from 'assets/payment/bancontact.png'
import EspImg from 'assets/payment/eps.png'
import GiropayImg from 'assets/payment/giropay.png'
import PrzelewyImg from 'assets/payment/przelewy.png'
import LinkImg from 'assets/payment/link.png'

export const allIcons = [
    { src: AppleImg, alt: 'Apple Pay' },
    { src: GoogleImg, alt: 'Google Pay' },
    { src: MasterImg, alt: 'Mastercard' },
    { src: VisaImg, alt: 'Visa' },
    { src: AmericanImg, alt: 'Amex' },
    { src: KlarnaImg, alt: 'Klarna' },
    { src: ObImg, alt: 'Open Banking' },
    { src: AmazonImg, alt: 'Amazon Pay' },
    { src: BlikImg, alt: 'Blik' },
    { src: DealImg, alt: 'iDeal' },
    { src: UnionImg, alt: 'UnionPay' },
    { src: JsbImg, alt: 'JCB' },
    { src: DiscoverImg, alt: 'Discover' },
    { src: BancontactImg, alt: 'Bancontact' },
    { src: EspImg, alt: 'EPS' },
    { src: GiropayImg, alt: 'Giropay' },
    { src: PrzelewyImg, alt: 'Przelewy24' },
    { src: LinkImg, alt: 'Link' }
];